<form  #mbOptOutSuccessForm="ngForm" name="mbOptOutSuccessForm">
    <p-dialog #LeasembOptOutModel header={{heading}} [visible]="true" [modal]="true" [closable]="false"
        [style]="{width: '600'}" [focusOnShow]="false">
        <div>
            <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
        </div>
       
        <div>
           <p *ngIf="invoice_date">You have successfully opted short code {{scId}} out of monthly billing. This short code was charged for the final time in monthly invoice {{monthly_invoice_id}}, issued on {{invoice_date | date:'M/d/yyyy'}}.</p>
           <p *ngIf="!invoice_date">You have successfully opted short code {{scId}} out of monthly billing. Monthly billing has not yet started for the short code.</p>
           <p>The new expiration date of the short code is {{expirationDate | date:'M/d/yyyy'}}.</p>
        </div>

        <p-footer>
            
            <div   class="d-flex justify-content-end me-2">
               
                <button i18n id="LeasembOptOutModelSuccess" class="btn btn-primary me-2" (click)="onSuccess()">Ok</button>
            </div>
        </p-footer>
    </p-dialog>

    
</form>
